// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"374":"158200ed","496":"7d225f88","520":"8561c858","592":"3397dba6","728":"64f94769","991":"e4795268"}[chunkId] + ".chunk.js";
};